import RowsPerPageSelect from "./RowsPerPageSelect.jsx";

// Matches the "Previous / Page X of Y / Next" + rows-per-page pattern already
// hand-rolled in AdminCustomersPage.jsx, extracted as a shared component.
export default function Pagination({ page, pages, limit, onLimitChange, onChange, limitOptions }) {
  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 10, marginTop: 16, flexWrap: "wrap" }}>
      <button
        type="button"
        className="btn btn-outline"
        onClick={() => onChange(page - 1)}
        disabled={page <= 1}
      >
        Previous
      </button>
      <span className="text-sm text-muted">Page {page} of {pages || 1}</span>
      <button
        type="button"
        className="btn btn-outline"
        onClick={() => onChange(page + 1)}
        disabled={page >= pages}
      >
        Next
      </button>
      <RowsPerPageSelect
        value={limit}
        options={limitOptions}
        onChange={(n) => { onLimitChange(n); onChange(1); }}
      />
    </div>
  );
}
